/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StationPositionWatchdog
 */
export interface StationPositionWatchdog {
    /**
     * 
     * @type {boolean}
     * @memberof StationPositionWatchdog
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StationPositionWatchdog
     */
    maxDistance?: number;
    /**
     * 
     * @type {string}
     * @memberof StationPositionWatchdog
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StationPositionWatchdog
     */
    uuid?: string;
}

/**
 * Check if a given object implements the StationPositionWatchdog interface.
 */
export function instanceOfStationPositionWatchdog(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StationPositionWatchdogFromJSON(json: any): StationPositionWatchdog {
    return StationPositionWatchdogFromJSONTyped(json, false);
}

export function StationPositionWatchdogFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationPositionWatchdog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'maxDistance': !exists(json, 'max_distance') ? undefined : json['max_distance'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function StationPositionWatchdogToJSON(value?: StationPositionWatchdog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'max_distance': value.maxDistance,
        'name': value.name,
        'uuid': value.uuid,
    };
}

